import React from 'react';
import CollapseAllIcon from '@mui/icons-material/UnfoldLess';
import { IconButton } from '@mui/material';

interface CollapseAllButtonProps {
  readonly collapseAll: (rowIds: readonly string[]) => void;
  readonly allCollapsableRowIds: readonly string[];
}

export function CollapseAllButton(props: CollapseAllButtonProps) {
  const { allCollapsableRowIds, collapseAll } = props;

  return (
    <IconButton
      onClick={(event) => {
        event.stopPropagation();
        collapseAll(allCollapsableRowIds);
      }}
    >
      <CollapseAllIcon />
    </IconButton>
  );
}
